import { PI2 } from '../../math';
import { ShapeLoop } from '../ShapeLoop';
/**
 * Spiral shape
 *
 * @category Shapes.ShapeLoop
 * @class Spiral
 * @extends {ShapeLoop}
 */
class Spiral extends ShapeLoop {
    /**
     * Creates an instance of Spiral.
     *
     * @param {SpiralSettings} [settings={}]
     * @memberof Spiral
     */
    constructor(settings = {}) {
        settings.type = 'Spiral';
        settings.bClosed = false;
        settings.loopDependencies = (settings.loopDependencies || []).concat(['twists', 'twistsStart', 'spiral']);
        super(settings, true);
        this.props.spiral = settings.spiral ?? Spiral.types.ARCHIMEDE;
        this.props.twists = settings.twists ?? 2;
        this.props.twistsStart = settings.twistsStart ?? 0;
        this.loop = {
            start: (propArguments) => PI2 * this.getProp('twistsStart', propArguments),
            end: (propArguments) => PI2 *
                (this.getProp('twistsStart', propArguments) + this.getProp('twists', propArguments)),
            inc: (propArguments) => {
                const twists = this.getProp('twists', propArguments);
                const rep = PI2 * twists;
                const sideLength = this.getRepetitionSideLength(propArguments);
                const radius = 4 + Math.sqrt(sideLength[0] * sideLength[1]);
                return rep / (radius * twists);
            },
            vertex: (shapeLoopRepetition) => {
                const r = this.r(shapeLoopRepetition.current);
                return [r * Math.cos(shapeLoopRepetition.current), r * Math.sin(shapeLoopRepetition.current)];
            },
        };
        this.bStaticLoop = this.isStaticLoop();
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
    generateLoopBuffer(propArguments) {
        this.spiral = this.getProp('spiral', propArguments);
        this.r = Spiral.getRFromTSpiralType(this.spiral);
        return super.generateLoopBuffer(propArguments);
    }
    /**
     * Point position and scale factor for spiral types
     *
     * @static
     * @param {TSpiralType} spiral
     * @returns {number}
     * @memberof Spiral
     */
    static getRFromTSpiralType(spiral) {
        switch (spiral) {
            case Spiral.types.ARCHIMEDE:
                return angle => angle / 10;
            case Spiral.types.HYPERBOLIC:
                return angle => (1 / angle) * 3;
            case Spiral.types.FERMAT:
                return angle => angle ** 0.5 / 3;
            case Spiral.types.LITUUS:
                return angle => angle ** -0.5;
            case Spiral.types.LOGARITHMIC:
                return angle => Math.E ** (angle * 0.2) / 10;
        }
        return angle => angle;
    }
}
/**
 * Spural types
 *
 * @static
 * @type {{ [name in TSpiralType]: TSpiralType }}
 * @memberof Spiral
 */
Spiral.types = {
    ARCHIMEDE: 'ARCHIMEDE',
    HYPERBOLIC: 'HYPERBOLIC',
    FERMAT: 'FERMAT',
    LITUUS: 'LITUUS',
    LOGARITHMIC: 'LOGARITHMIC',
};
export { Spiral };
//# sourceMappingURL=Spiral.js.map